<template>
  <el-aside class="aside" width="40%">
    <div class="aside-content">
      <div class="tit">Monetization Platform for Publishers</div>
      <div class="desc">
        Youmi offers a full stack of ad monetization solutions for digital publishers & app
        developers. Accelerate your selling efforts with our yield management platform, maximize
        revenues with multiple demand sources. Sign up and sell traffic with the best eCPM rates
        now!
      </div>
      <div class="contact">
        <div class="contact-tit">Contact AM</div>
        <div class="contact-item" v-for="(am, index) in am_list" :key="index">
          <div class="contact-container">
            <img class="avatar" src="../assets/img/st-icon3.png" />
            <div class="contact-message">
              <div class="msg-item">
                <i class="icon-y-fullname icon-grey mr-1"></i>
                <label>{{ am.name }}</label>
              </div>
              <div class="msg-item">
                <i class="icon-y-skype icon-grey mr-1"></i>
                <label>{{ am.skype }}</label>
              </div>
              <div class="msg-item">
                <i class="icon-y-email2 icon-grey mr-1"></i>
                <label>{{ am.email }}</label>
              </div>
              <div class="msg-item">
                <i class="icon-y-whatsapp icon-grey mr-1"></i>
                <label>{{ am.whatsapp }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: 'commonAside',
  data() {
    return {
      am_list: [
        {
          name: 'Doria',
          email: 'mkt@youmi.net',
          skype: 'mkt@youmi.net',
          whatsapp: '+86 18028539642',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.aside {
  background: url(../assets/img/bg-aff.jpg) no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  .aside-content {
    width: 480px;
    color: #ffffff;
    .tit {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 32px;
    }
    .desc {
      line-height: 24px;
      text-align: justify;
      text-justify: inter-ideograph;
      margin-bottom: 32px;
    }
    .contact {
      .contact-tit {
        border-left: 4px solid #e30077;
        padding-left: 8px;
        margin-bottom: 8px;
      }
      .contact-item {
        box-sizing: border-box;
        width: 480px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 8px;
        .caption {
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 12px;
        }
        .contact-container {
          display: flex;
          .avatar {
            display: block;
            width: 48px;
            height: 48px;
          }
          .contact-message {
            width: 384px;
            height: 48px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-left: 12px;
            .msg-item {
              width: 50%;
              height: 22px;
              line-height: 22px;
              color: #c0c4cc;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
